module.exports = __webpack_public_path__ + "img/45b619d.jpg";